var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(null === _vm.items)?[_c('base-loader',{key:"loader"})]:(false === _vm.items)?[(false === _vm.items)?_c('base-error-message',{key:"error"},[_vm._t("default")],2):_vm._e()]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }